<template>
  <div id="transfer">
    <div v-if="showTip" class="download-tip"></div>
  </div>
</template>

<script>
import { downloadApps } from '../api'
import { wechatBrowser, analysisParams } from '@/utils/utils'
export default {
  name: "Transfer",
  data: () => {
    return {
      showTip: false,
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1168343.apk',
        ios_url: 'https://apps.apple.com/cn/app/%E9%98%BF%E7%91%9E%E6%96%AF%E7%97%85%E6%AF%922/id6503130455',
      },
    }
  },
  created() {
    document.title = 'loading...' // 修改网站标题
    const params = analysisParams(window.location.href);
    const { download_id, title } = params;
    downloadApps({ download_id, title }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
      if (wechatBrowser()) {
        // 弹窗
        this.showTip = true
      } else {
        setTimeout(() => {
          // IOS
          if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
            window.location.href = this.downloadUrls.ios_url
          } else {
            window.location.href = this.downloadUrls.android_url
          }
        }, 200)
      }
    })
  }
};
</script>

<style lang="less" scoped>
#transfer {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
  .download-tip {
    width: 100%;
    height: 100%;
    background: url('https://download4.qcplay.com/h5-images/active/hjwq/bank/download_bg.jpg')
      no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ares/anniversary/download/index.vue